var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "instant-payment-wrapper",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px; background-color: #f9f9fb;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                      on: { "click-left": _vm.handleBack },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.instantPayment.title"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("lang.instantPayment.text1"))),
          ]),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("lang.instantPayment.text2"))),
          ]),
          _vm._l(_vm.conditionsList, function (item) {
            return [
              _c("div", { key: item.condition, staticClass: "status-item" }, [
                _c(
                  "div",
                  { staticClass: "left" },
                  [
                    item.checkResult
                      ? [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                staticClass: "icon",
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/success-kiko.png"),
                                  alt: "icon",
                                  width: "18",
                                  height: "18",
                                },
                              })
                            : _c("img", {
                                staticClass: "icon",
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/success.png"),
                                  alt: "icon",
                                  width: "18",
                                  height: "18",
                                },
                              }),
                        ]
                      : [
                          _c("img", {
                            staticClass: "icon",
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/Withdrawal/vava/fail.png"),
                              alt: "icon",
                              width: "18",
                              height: "18",
                            },
                          }),
                        ],
                    _c("span", { staticClass: "text" }, [
                      _vm._v(_vm._s(item.condition)),
                    ]),
                  ],
                  2
                ),
                _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(item.performance)),
                ]),
              ]),
            ]
          }),
          _c("div", { staticClass: "support" }, [
            _vm._v(_vm._s(_vm.$t("lang.instantPayment.payTitle"))),
          ]),
          _vm.isSupport
            ? [
                _c("div", { staticClass: "no-support" }, [
                  _vm._v(_vm._s(_vm.$t("lang.instantPayment.nonsupport"))),
                ]),
              ]
            : [
                _vm._l(_vm.channelsList, function (item) {
                  return [
                    _c("div", { key: item.name, staticClass: "organization" }, [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: _vm._f("imgPath")(item.icon),
                          alt: "icon",
                          height: "18",
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(item.name))]),
                    ]),
                  ]
                }),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }